import FormComponent from '../FormComponent';
import { Events } from '../../utils/dom/html-events';
import Request, { ApiMode } from '../../utils/request';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import FormGenerator, { FormTypes } from '../FormGenerator';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';
const IS_LOCAL = false;
export const EVENT_UPDATE_PLAYER_DATA = `EVENT_UPDATE_PLAYER_DATA`;

class PlayerList extends FormComponent {
	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}
	markup(value, data, titleMarkup) {
		this.stepsCount = this.data.fieldName === 'additionalChildernData' ? 3 : 1;
		this.buttonText = this.data.fieldName === 'additionalChildernData' ? 'Add child' : 'Add Player';
		this.modalWrapperId =
			this.data?.fieldname === 'additionalChildernData' ? 'js-add-children-modal' : 'js-add-player-modal';
		this.modalExitButtonClass =
			this.data?.fieldname === 'additionalChildernData' ? `js-exit-add-chidren` : `js-exit-add-additional-player`;
		this.moadlContetntWrapperId =
			this.data?.fieldname === 'additionalChildernData' ? 'js-checkout-add-children' : 'js-checkout-add-player';
		this.addPlayerLinkClass =
			this.data?.fieldname === 'additionalChildernData'
				? 'js-trigger-add-associated-children'
				: 'js-trigger-add-additional-player';
		return `
            <div class="u-mb-4 u-pt-0">
                <div class="u-subtitle1 sm:u-mb-5 md:u-mb-3">${titleMarkup}</div>
				${data?.instructionText ? `<p class="lta-text-input__label u-text-grey-lta u-body1">${data?.instructionText}</p>` : ''}
				${data?.errorMessage !== '' ? this.showErrorContainer() : ''}
				${data?.supportingProps.players
					? data.supportingProps.players.map((player) => `
						<div class="p-lta-player-list u-flex u-align-center u-my-2">
							<div class="u-bg-background-blue u-h-100 u-w-100 u-p-2 u-rounded">
								<div class="u-h6">${player.name}</div>
								<div class="u-body1">${[player?.gender, player.ageText].filter(Boolean).join(', ')}</div>
							</div>
						</div>`).join('')
					: ''
				}
				${this.renderAddPlayerLink()}
				${this.renderModal()}
            </div>
        `;
	}

	showErrorContainer() {
		return `
			<div class="p-add-player-error-container lta-snackbar lta-snackbar--hard-alert has-icon u-mb-3">
				<p class="p-add-player-error-content lta-snackbar__label title title">${this.data?.errorMessage}</p>
				<button type="button" class="lta-btn lta-btn__error-dismiss lta-btn--sm lta-btn--primary u-mt-1">Close</button>
				<div class="lta-snackbar__icon">
					<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" style="color:currentColor;" fill="currentColor" alt="info" aria-hidden="true"><use xlink:href="/static/images/icons/lta-icons.svg#info"></use></svg>
				</div> 
			</div>
		`;
	}

	renderAddPlayerLink() {
		return `${this.data.supportingProps.allowNewPlayer
			? `	<button type="button" class="${this.addPlayerLinkClass} lta-btn lta-btn--lg lta-btn--link u-text-lta-dark-blue">
					${this.data?.supportingProps?.additionalPlayerText}
				</button>`
			: ''
		}`;
	}

	renderModal() {
		return `
		${this.data.supportingProps.allowNewPlayer
			? ` <div class="lta-modal u-hidden"  id=${this.modalWrapperId} tabindex="-1" aria-labelledby="p-add-additional-player-label" aria-modal="true" role="dialog">
					<div class="lta-add-player lta-modal-dialog lta-modal-fullscreen">
						<div class="lta-modal-content">
							<div class="p-add-additional-player--exit-button u-flex u-justify-end u-p-2">
								<button type="button" class=" ${this.modalExitButtonClass} lta-btn lta-btn--default lta-btn--link lta-btn--icon lta-btn--icon-after u-text-lta-dark-blue" data-dismiss="modal">
									Exit
									<svg class="lta-icon js-lta-text-input--btn-icon u-ml-0" width="1.5em" height="1.5em" style="color:currentColor;" fill="currentColor" alt="close" aria-hidden="true">
										<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
									</svg>
								</button>
							</div>						
							<div class="l-grid l-lta-grid">
								<div class="g-col-12 g-col-md-3 g-col-xl-4"></div>
								<div class="g-col-12 g-col-md-6 g-col-xl-4">
									<div class="p-add-additional-player-error-container u-justify-center u-hidden u-my-3 u-hstack" role="alertdialog">
										<div class="lta-snackbar lta-snackbar--alert has-icon">
											<p class="lta-snackbar__label title error-text u-text-center" aria-label="error" onclick=""></p>
											<button type="button" class="lta-btn lta-btn--sm lta-btn--inverse lta-btn--block u-ml-1 js-dismiss-error">Close</button>
											<div class="lta-snackbar__icon">
												<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="alert" aria-hidden="true">
													<use xlink:href="/static/images/icons/lta-icons.svg#alert"></use>
												</svg>
											</div>
										</div>
									</div>
									<div class="xl:u-mt-0 md:u-mt-6">
										<div class="lta-modal-content" id=${this.moadlContetntWrapperId}></div>
									</div>
								</div>
							</div>	
						</div>
					</div>
				</div>`
			: ''
		}`;
	}

	afterRender() {
		const addChildrenSelector = SelectorEngine.findOne('.js-trigger-add-associated-children', this.containerEl);
		const addPlayerSelector = SelectorEngine.findOne('.js-trigger-add-additional-player', this.containerEl);

		this.modalEl = SelectorEngine.findOne(`#${this.modalWrapperId}`, this.containerEl);
		this._modal = new Modal(this.modalEl, { backdrop: 'static', isEscapeEventEnable: true });
		const exitModalSelector = SelectorEngine.findOne(`.${this.modalExitButtonClass}`, this.containerEl);

		this.questions = SelectorEngine.findOne(`#${this.moadlContetntWrapperId}`, this.containerEl);

		this.errorCloseSelector = SelectorEngine.findOne('.lta-btn__error-dismiss', this.containerEl);

		EventHandler.on(addChildrenSelector, Events.Click, () => {
			this._modal.show();
			this.getFormDetails(this.data.supportingProps.getAddPlayerForm.endpoint);
		});

		EventHandler.on(addPlayerSelector, Events.Click, () => {
			this._modal.show();
			this.getFormDetails(this.data.supportingProps.getAddPlayerForm.endpoint);
		});

		EventHandler.on(exitModalSelector, Events.Click, () => {
			this._modal.hide();
			this.render();
		});

		EventHandler.on(this.errorCloseSelector, Events.Click, () => {
			this.updateError('');
		});

		// Add event listener for escape key		
		EventHandler.on(document, 'keydown', (event) => {
			if (event.key === 'Escape') {
				this._modal.hide();
				this.render();
			}
		});
	}

	async getFormDetails(endpoint) {
		startLoadingAnimation();
		try {
			const url = endpoint;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				stopLoadingAnimation();
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				stopLoadingAnimation();
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: this.stepsCount,
			hasSeparator: false,
			isHideProgress: this.stepsCount === 1,
			formType: this.stepsCount === 1 ? FormTypes.SectionForm : FormTypes.StepForm,
			isBackButtonEnabled: this.stepsCount > 1,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			submitButton: {
				title: this.buttonText,
				alwaysVisible: true
			}
		});

		this.formGenerator.onChange(async (answers) => {
			const _answers = this.prepareRequestObject(answers);
			const payload = this.generatePayload(_answers);
			this._modal.hide();
			this.render();
			this.saveAddWorkCardSteps(payload);
		});
	}

	prepareRequestObject(stepsAnswers) {
		let answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				answerList = {
					...answerList,
					...formatObject
				};
			}
		}
		return answerList;
	}

	async saveAddWorkCardSteps(payload) {
		startLoadingAnimation();
		try {
			const url = this.data?.supportingProps?.addPlayer?.endpoint;
			const responseData = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { response, error } = responseData;
			if (error?.hasError !== true) {
				this.updatePlayers(response);
				this.updateError('');
			} else {
				stopLoadingAnimation();
				this.containerEl.scrollTop = 0;
				this.updateError(error.errorMessage);
			}
		} catch (error) {
			if (error.hasError) {
				stopLoadingAnimation();
				console.log('Error :', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	generatePayload(data) {
		const payload = {
			firstName: data?.firstName,
			lastName: data?.lastName,
			birthDate: data?.birthDate,
			gender: data?.gender,
			address: {
				type: 'PostalAddress',
				streetAddress: data.address?.street,
				addressLocality: data.address?.city,
				addressRegion: data.address?.state,
				postalCode: data.address?.postCode,
				addressCountry: 'GB'
			},
			contactNo: data?.contactNo,
			relationshipWithContact: data?.relationshipWithContact,
			healthIssues: data?.healthIssues === "yes" ? data?.additionalInfo : ""
		};
		return payload;
	}

	updatePlayers(player) {
		this.data = {
			...this.data,
			supportingProps: {
				...this.data.supportingProps,
				players: [
					...this.data.supportingProps.players,
					player
				]
			}
		};
		// Update the playerName
		this.updatePlayerNamesList(player.name);
	}

	updateError(message) {
		this.data = {
			...this.data,
			errorMessage: message
		};
	}

	updatePlayerNamesList(data) {
		const playerName = data;
		EventHandler.trigger(SelectorEngine.findOne('body'), EVENT_UPDATE_PLAYER_DATA, { updatedData: playerName });
	}
}

export default PlayerList;
